import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useRequestFactory } from './factories/requestFactory'
import { OneinchV2Service } from '@/services/oneinch-v2-service2'
import { CHAIN_TO_ID } from '@/utils/oneinch'

type ActionFlag = 'allowance' | 'spender' | 'approve' | 'swap'

export const use1InchStore = defineStore('1inch', () => {
  const { requestHandler } = useRequestFactory<ActionFlag>()

  const apiKey = ref('')

  const checkAllowance = async (chain: string, token: string, wallet: string) => {
    const chainId = CHAIN_TO_ID[chain]
    if (!chainId) throw new Error(`Unsupported chain: ${chain}`)
    return await requestHandler('allowance', async () => {
      const req = await OneinchV2Service.checkAllowance(apiKey.value, chainId, token, wallet)
      return req.data
    })
  }

  const fetchSpender = async (chain: string) => {
    const chainId = CHAIN_TO_ID[chain]
    if (!chainId) throw new Error(`Unsupported chain: ${chain}`)
    return await requestHandler('spender', async () => {
      const req = await OneinchV2Service.fetchSpender(apiKey.value, chainId)
      return req.data
    })
  }

  const approve = async (chain: string, token: string) => {
    const chainId = CHAIN_TO_ID[chain]
    if (!chainId) throw new Error(`Unsupported chain: ${chain}`)
    return await requestHandler('approve', async () => {
      const req = await OneinchV2Service.approve(apiKey.value, chainId, token)
      return req.data
    })
  }

  const fetchSwapCalldata = async (
    chain: string,
    tokenFrom: string,
    tokenTo: string,
    walletAddress: string,
    amount: bigint,
    slippage: string | null,
  ) => {
    const chainId = CHAIN_TO_ID[chain]
    if (!chainId) throw new Error(`Unsupported chain: ${chain}`)
    return await requestHandler('swap', async () => {
      const req = await OneinchV2Service.fetchSwapCalldata(
        apiKey.value,
        chainId,
        tokenFrom,
        tokenTo,
        walletAddress,
        amount.toString(),
        slippage,
      )
      return req.data
    })
  }

  const fetchQuote = async (chain: string, tokenFrom: string, tokenTo: string, amount: bigint) => {
    const chainId = CHAIN_TO_ID[chain]
    if (!chainId) throw new Error(`Unsupported chain: ${chain}`)
    return await requestHandler('swap', async () => {
      const req = await OneinchV2Service.fetchQuote(apiKey.value, chainId, tokenFrom, tokenTo, amount.toString())
      return req.data
    })
  }

  return {
    apiKey,
    fetchSpender,
    fetchSwapCalldata,
    fetchQuote,
    checkAllowance,
    approve,
  }
})
